<template>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Entité:</label>
        </div>
        <div class="col-lg-9">
          <Dropdown
              class="input-width-100"
              v-model="entite"
              :options="entiteLibelles"
              optionValue="valeur"
              optionLabel="texte"
              scrollHeight="700px"
              :showClear="true"
          />
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Site d'origine:</label>
        </div>
        <div class="col-lg-9">
          <Dropdown
              class="input-width-100"
              v-model="site"
              :options="sitesLibelles"
              optionValue="valeur"
              optionLabel="texte"
              scrollHeight="205px"
              :showClear="true"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Du:</label>
        </div>
        <div class="col-lg-9">
          <CustomInputDate
              class="input-width-100"
              type="date"
              max="9999-12-31"
              v-model="dateDu"
          />
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Au:</label>
        </div>
        <div class="col-lg-9">
          <CustomInputDate
              class="input-width-100"
              type="date"
              max="9999-12-31"
              v-model="dateAu"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomInputDate from '../../Commun/CustomInputDate.vue'

export default {
  name: "CritereRechercheComiteDeVigilance",
  emits: ['rechercher'],
  components: {
    CustomInputDate
  },
  data() {
    return {
      entite: null,
      entiteLibelles: [],
      site: null,
      sitesLibelles: [],
      dateDu: null,
      dateAu: null,
      criteresRecherche: {},
    };
  },
  methods: {
    assignerListe(entiteDecision) {
      this.entiteLibelles = entiteDecision.entite.libelles;
      this.$store.dispatch("dossier/obtenirSiteEntiteAction").then((res) => {
        this.entite = res.data.entite;
        this.site = res.data.site;
        this.dateDefault();
      });
    },
    dateDefault() {
      let dateDefaut = new Date();
      this.dateDu = this.$commun.formatDate(dateDefaut.setDate(dateDefaut.getDate() - 7));
      this.dateAu = this.$commun.formatDate(new Date());
    },
    getCriteresRecherche() {
      if (this.dateAu !== null && this.dateAu !== undefined) {
        this.criteresRecherche.dateAu = new Date(this.dateAu);
      }
      if (this.dateDu !== null && this.dateDu !== undefined) {
        this.criteresRecherche.dateDu = new Date(this.dateDu);
      }
      this.criteresRecherche.entite = this.entite;
      this.criteresRecherche.site = this.site;

      return this.criteresRecherche;
    }
  },
  watch: {
    entite: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch("narration/onChangeEntityAction", {
          libelleChange: 'Site',
          nouvelleValeur: val
        })
            .then((res) => {
              this.sitesLibelles = res.data;
            });
      } else {
        this.site = null;
        this.sitesLibelles = [];
      }
    },
  }
}
</script>